import { render, staticRenderFns } from "./IdeaCard.vue?vue&type=template&id=5f4ded5e&scoped=true"
import script from "./IdeaCard.vue?vue&type=script&lang=js"
export * from "./IdeaCard.vue?vue&type=script&lang=js"
import style0 from "./IdeaCard.vue?vue&type=style&index=0&id=5f4ded5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ded5e",
  null
  
)

export default component.exports